//const Snap = require("snapsvg/dist/snap.svg.js");
//const Snap = require("imports-loader?this=>window,fix=>module.exports=0");

export const getViewBox = (rawSvg) => {
	const viewBoxValue = readAttributeValue(rawSvg, "viewBox");
	if (viewBoxValue) return viewBoxValue;

	const widthValue = readAttributeValue(rawSvg, "width");
	const heightValue = readAttributeValue(rawSvg, "height");
	if (widthValue && heightValue) return "0 0 " + widthValue + " " + heightValue;

	return "0 0 200 200";
};

export const getPath = (rawSvg) => {
	const pathStartIndex = rawSvg.indexOf("<path");
	return (
		readAttributeValue(
			rawSvg.substring(pathStartIndex, rawSvg.length - 1),
			" d"
		) || ""
	);
};

export const getFillColor = (rawSvg) => {
	const value = readAttributeValue(rawSvg, "fill");
	return /^#[0-9a-fA-F]{6}/.test(value) ? value : undefined;
};

const readAttributeValue = (htmlString, key) => {
	const startIndex = htmlString.indexOf(key + "=");
	if (startIndex < 0) return undefined;
	else {
		const keyLength = key.length + 2;
		const endIndex = htmlString.indexOf('"', startIndex + keyLength);
		if (endIndex < 0) return undefined;
		return htmlString.substring(startIndex + keyLength, endIndex);
	}
};
